<template>
  <div>
    <el-card class="card">
      <slot></slot>
    </el-card>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      click: false
    }
  },
  methods: {}
};
</script>

<style scoped>
.card {
  height: 400px;
  width: 400px;
  border-radius: 10px;
  display:flex;
  justify-content: center;
  align-items:center;
}
</style>